import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ManagedPricing } from './interfaces';

interface AdminClientManagedPricingDetailState {
    managedPricing: ManagedPricing | null;
}

const initialState: AdminClientManagedPricingDetailState = {
    managedPricing: null,
};

export const adminClientManagedPricingDetailSlice = createSlice({
    name: 'adminClientManagedPricingDetail',
    initialState,
    reducers: {
        init: (
            state: AdminClientManagedPricingDetailState,
            action: PayloadAction<ManagedPricing>
        ) => {
            state.managedPricing = action.payload;
        },
        replace: (
            state: AdminClientManagedPricingDetailState,
            action: PayloadAction<ManagedPricing>
        ) => {
            state.managedPricing = action.payload;
        },
    },
});

export const { init, replace } = adminClientManagedPricingDetailSlice.actions;

export default adminClientManagedPricingDetailSlice.reducer;
